import styled from "styled-components";
import { theme } from "../../theme";

export const AvailableExamsGrid = styled.div`
display: grid;
grid-template-columns: repeat(auto-fit, minmax(34.6rem, 1fr));
grid-column-gap: 1.7rem;
grid-row-gap: 3.6rem;
margin-bottom: 5.5rem;
`;